import axios from 'axios';
import router from '../Router/index';
export default {
  namespaced: true,
  state: {
    openButton: false,
    isDropDownActiveOne: false,
    isDropDownActiveTwo: false
  },
  getters: {
    getOpenButton(state) {
      return state.openButton;
    },
    getisDropDownActiveOne(state) {
      return state.isDropDownActiveOne;
    },
    getisDropDownActiveTwo(state) {
      return state.isDropDownActiveTwo;
    }
  },
  mutations: {
    SET_UPDATED_MANAGEMENT(state, value) {
      state.openButton = value;
    },
    SET_UPDATED_MANAGEMENT_LIST_ONE(state, value) {
      state.isDropDownActiveOne = value;
    },
    SET_UPDATED_MANAGEMENT_LIST_TWO(state, value) {
      state.isDropDownActiveTwo = value;
    }
  },
  actions: {
    management_list_updated({ commit }, value) {
      commit('SET_UPDATED_MANAGEMENT', value);
    },
    management_list_updated_isDropDownActiveOne({ commit }, value) {
      commit('SET_UPDATED_MANAGEMENT_LIST_ONE', value);
    },
    management_list_updated_isDropDownActiveTwo({ commit }, value) {
      commit('SET_UPDATED_MANAGEMENT_LIST_TWO', value);
    }
  }
};
